import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs, doc, getDoc, addDoc, updateDoc } from 'firebase/firestore';
import Footer from '../Components/footer';
import Navbar from '../Components/NavBarV2';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import './reservasRealizadas.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/free-solid-svg-icons';
import Trofeo from '../img/logoprueba.png';
import { db, auth } from '../Firebase/Firebase';
import Rating from 'react-rating-stars-component'; // Asegúrate de tener esta librería
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ReservasRealizadas = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState(''); // Estado para el término de búsqueda
  const [reservations, setReservations] = useState([]);
  const [spaces, setSpaces] = useState({});
  const [groupedReservations, setGroupedReservations] = useState({});
  const [selectedReservation, setSelectedReservation] = useState(null); // Reserva seleccionada para la reseña
  const [showModal, setShowModal] = useState(false);
  const [calificacion, setCalificacion] = useState(0);
  const [comentario, setComentario] = useState('');

  const [selectedReservationId, setSelectedReservationId] = useState(null);


  useEffect(() => {
    const fetchReservations = async () => {
      onAuthStateChanged(auth, async (user) => {
        console.log("Usuario autenticado: ", user?.uid); // Verificar el uid
  
        try {
          const reservationsQuery = user?.uid
            ? query(collection(db, 'reservas'), where('idUser', '==', user.uid))
            : query(collection(db, 'reservas'));
  
          const querySnapshot = await getDocs(reservationsQuery);
          const fetchedReservations = [];
          const fetchedSpaces = {}; // Almacenará todos los espacios
  
          // Itera sobre las reservas
          for (const snapshotDoc of querySnapshot.docs) {
            const reserva = snapshotDoc.data();
            const reservaId = snapshotDoc.id;
  
            // Obtener datos del cliente
            const userDocRef = doc(db, 'usuarios', reserva.idUser);
            const userDoc = await getDoc(userDocRef);
            let fullName = 'Usuario desconocido';
  
            if (userDoc.exists()) {
              const userData = userDoc.data();
              const name = userData.name || '';
              const lastname = userData.lastName || '';
              fullName = [name, lastname].filter(Boolean).join(' ') || 'Usuario desconocido';
            }
  
            reserva.userName = fullName;
            console.log(`Buscando espacio con ID: ${reserva.IdEspacio}`);
            // Obtener datos del espacio
            if (reserva.IdEspacio) {
             
              const espacioDocRef = doc(db, 'espacios', reserva.IdEspacio);
              const espacioDoc = await getDoc(espacioDocRef);
  
              if (espacioDoc.exists()) {
                const espacioDataDoc = espacioDoc.data();
                let tipoEspacioNombre = '';
  
                if (espacioDataDoc.TipoEspacio) {
                  const tipoEspacioRef = doc(db, 'tipoespacio', espacioDataDoc.TipoEspacio);
                  const tipoEspacioDoc = await getDoc(tipoEspacioRef);
                  if (tipoEspacioDoc.exists()) {
                    tipoEspacioNombre = tipoEspacioDoc.data().TipoEspacio || '';
                  }
                }
  
                // Verifica que se obtuvieron los datos correctamente del espacio
                console.log(`Datos de espacio obtenidos para ID: ${reserva.IdEspacio}: `, espacioDataDoc);
  
                const spaceData = {
                  imagen: espacioDataDoc.Imagenes?.[0] || 'defaultImage.jpg',
                  nombreEspacio: espacioDataDoc.NombreEspacio || 'Espacio',
                  tipoEspacio: tipoEspacioNombre,
                  logo: espacioDataDoc.logo ,
                };
  console.log(spaceData.logo)
                // Guarda el espacio
                fetchedSpaces[reserva.idEspacio] = spaceData;
  
                console.log(`Datos de espacio añadidos a fetchedSpaces para ID: ${reserva.idEspacio}: `, spaceData);
              } else {
                console.log(`No se encontró documento de espacio para ID: ${reserva.idEspacio}`);
              }
            }
  
            // Unimos la reserva con los datos del espacio (aquí aún no agregamos espacio a la reserva)
            fetchedReservations.push({ ...reserva, id: reservaId , fetchedSpaces});
          }
  
          // Asegurémonos de que fetchedSpaces contiene los datos
          console.log("Datos completos de espacios: ", fetchedSpaces);
  
          // Actualizamos el estado con las reservas y los espacios
          setReservations(fetchedReservations);
          setSpaces(fetchedSpaces);
  
        } catch (error) {
          console.error('Error al obtener las reservas:', error);
        }
      });
    };
  
    fetchReservations();
  }, []);
  


  const filteredReservations = reservations.filter((reserva) => {
    return (
      spaces[reserva.idEspacio]?.nombreEspacio.toLowerCase().includes(searchTerm.toLowerCase()) // Filtra según el nombre del espacio
    );
  });
console.log(filteredReservations)
  const nextReservation = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % filteredReservations.length);
  };

  const prevReservation = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + filteredReservations.length) % filteredReservations.length);
  };

  /*const handleReservationClick = (reserva) => {
    console.log('Reserva seleccionada:', reserva); // Verifica los valores de la reserva
    setSelectedReservation(reserva); // Guardar la reserva seleccionada
    setShowModal(true); // Mostrar el modal
  };*/
  const handleReservationClick = (reservaId) => {
    setSelectedReservationId(reservaId); // Almacenar el id de la reserva seleccionada
    setShowModal(true); // Mostrar el modal
  };



  const closeModal = () => {
    setShowModal(false);
    setCalificacion(0);
    setComentario('');
  };
  const handleSaveCalificacion = async (reservaId) => {

    if (!reservaId || typeof reservaId !== 'string') {
      console.error('ID de reserva no es válido', reservaId);
      return;
    }

    try {
      const reservaDocRef = doc(db, 'reservas', reservaId);
      const reservaDoc = await getDoc(reservaDocRef);

      if (reservaDoc.exists()) {
        const reservaData = reservaDoc.data();

        if (reservaData.reseñaRealizada) {
          toast.error("Ya se ha realizado una reseña para esta reserva.");
          return;
        }

        // Proceder con el guardado de la reseña
        const { idEspacio, idUser } = reservaData;
        if (!idEspacio || !idUser) {
          console.error('Datos de reserva incompletos.');
          return;
        }

        const docRef = await addDoc(collection(db, 'reseñas'), {
          idEspacio,
          Reseña: comentario,
          calificacion,
          userId: idUser,
        });

        // Marcar la reseña como realizada
        await updateDoc(reservaDocRef, { reseñaRealizada: true });

        // Cerrar el modal o realizar cualquier acción posterior
        closeModal();
      } else {
        console.error('No se encontró la reserva.');
      }
    } catch (e) {
      console.error('Error al guardar reseña o actualizar reserva: ', e);
    }
  };









  return (
    <div>
      <Navbar />
      <ToastContainer />

      <br/><br/>
      <div className="Presentation2">
        <img className="imagenlateral1" src={Lateral1} alt="Lateral" />
        <div className="fondo2">
          <h2 className="reservaTitulo">RESERVAS REALIZADAS</h2>

          {/* Filtro de búsqueda */}
          <input
            type="text"
            placeholder="Buscar espacio"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginBottom: '-4px' }}
          />


          {Array.isArray(filteredReservations) && filteredReservations.length > 0 ? (
            <div key={filteredReservations[currentIndex]?.id || currentIndex} className="profile-form2">
              {/* Información previa al filtro */}
              <button className="prev-btn-reservas" onClick={prevReservation}>
                ❮
              </button>

              <div className="form-grid2">
                {/* Primera columna */}
                <div className="form-column">
                  <div className="floating-label">
                    <img
                      className="Image1Reserva"
                      src={spaces[filteredReservations[currentIndex]?.idEspacio]?.imagen || 'https://via.placeholder.com/150'}
                      alt="Espacio"
                    />
                  </div>
                  <div className="floatinglabel2">
                    <div className="row-i">
                      <h4>Tu espacio</h4>
                      <div className="headerReserva">
                        <FontAwesomeIcon className="iconerror2" icon={faCrown} />
                        <p>
                          {spaces[filteredReservations[currentIndex]?.idEspacio]?.nombreEspacio || 'Nombre de Espacio'}
                        </p>
                      </div>
                    </div>
                    <div className="row-i">
                      <h3 style={{ color: '#648dcb' }}>
                        {filteredReservations[currentIndex]?.userName || 'Usuario'}
                      </h3>
                      <img
                        className="iconTrofeo"
                        src={spaces?.[filteredReservations[currentIndex]?.idEspacio]?.logo || Trofeo
                        }
                        alt="Logo"
                      />
                    </div>
                    <div className="row-i">
                      <h3>Activado</h3>
                      <h4 style={{ color: '#648dcb' }}>
                        {spaces[filteredReservations[currentIndex]?.idEspacio]?.tipoEspacio || 'Sala de reuniones'}
                      </h4>
                    </div>
                  </div>
                </div>

                {/* Segunda columna */}
                <div className="form-column">
                  <div className="floatinglabel3">
                    <p>DATOS DE LA RESERVA</p>
                  </div>
                  <div className="floatinglabel4">
                    <div className="row">
                      <h4>Fecha de Inicio</h4>
                      <p>{filteredReservations[currentIndex]?.fechaInicio || 'N/A'}</p>
                    </div>
                    <div className="Divider"></div>
                    <div className="row">
                      <h4>Fecha de Final</h4>
                      <p>{filteredReservations[currentIndex]?.fechaFinal || 'N/A'}</p>
                    </div>
                    <div className="Divider"></div>
                    <div className="row">
                      <h4>Hora/Inicio</h4>
                      <p>{filteredReservations[currentIndex]?.horaInicio || 'N/A'}</p>
                    </div>
                    <div className="Divider"></div>
                    <div className="row">
                      <h4>Hora/Final</h4>
                      <p>{filteredReservations[currentIndex]?.horaFinal || 'N/A'}</p>
                    </div>
                    <div className="Divider"></div>

                    <button
                      className="botonResenia"
                      onClick={() => handleReservationClick(filteredReservations[currentIndex]?.id)}
                    >
                      Reseña
                    </button>
                  </div>
                </div>
              </div>

              <button className="next-btn-reservas" onClick={nextReservation}>
                ❯
              </button>
            </div>
          ) : (
            <p>No hay reservas disponibles</p>
          )}


        </div>
        <img className="imagenlateral2" src={Lateral2} alt="Lateral" />
      </div>

      {showModal && (
        <div className="modal_res_prov">
          <h2>Raliza tu reseña del espacio</h2>

          <div className="comentario_prov">
            <p>Calificación:</p>
            <Rating
              count={5}
              value={calificacion}
              onChange={setCalificacion}
              size={30}
              activeColor="#ffd700"
              style={{
                textAlign: 'center', // Centra el componente horizontalmente
                display: 'inline-block', // Asegura que no ocupe todo el ancho
                margin: '0 auto', // Centra el contenedor si es un bloque
              }}
            />

            <p>Comentario:</p>
            <textarea
              style={{ width: '90%' }}
              rows="4"
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </div>

          <div className="btnModal">
            <button className='cancelar_reseña' onClick={closeModal}>Cancelar</button>
            <button className='guardar_reseña'
              onClick={() => handleSaveCalificacion(selectedReservationId)}
            >
              Guardar Reseña
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReservasRealizadas;